import React, { Component } from 'react';
import { connect } from 'react-redux';

import ViewToggle from '../../common/files/filters/ViewToggle';
import Dropdown from '../../common/files/filters/Dropdown';
import NoFiles from '../../common/files/NoFiles';
import FileTable from '../../common/files/FileTable';
import FileGrid from '../../common/files/FileGrid';
import Offset from '../../common/files/filters/Offset';
import Button from '../../common/form/Button';
import * as fromFiles from '../../../store/files/reducer';
import * as fromCircles from '../../../store/circles/reducer';
import * as fromTypes from '../../../store/types/reducer';
import * as fromFunds from '../../../store/funds/reducer';
import * as fromYears from '../../../store/years/reducer';
import { anyActiveFilters } from '../../../store';
import { updateCurrentPage, setView, setFileSortOrder, setFileViewed } from '../../../store/files/actions';
import { toggleDropdown, toggleCheckFilter, clearFilters } from '../../../store/actions';
import './my-files.css';

class MyFiles extends Component {
	
	render() {
		const { 
			files,
			circles,
			isCirclesActive,
			types,
			isTypesActive,
			funds,
			isFundsActive,
			years,
			isYearsActive,
			pages,
			currentPage,
			view,
			sort,
			order,
			activeToggle,
			updateCurrentPage,
			setView, 
			setFileSortOrder,
			toggleDropdown,
			toggleCheckFilter,
			clearFilters,
			showClear,
			setFileViewed,
		} = this.props;

		const renderFiles = () => {
			if (!files.length) {
				return <NoFiles clearFilters={clearFilters} />
			}

			if (view === "list") {
				return <FileTable files={files} sort={sort} order={order} onSortClick={setFileSortOrder} handleFileClick={setFileViewed} />
			} else {
				return <FileGrid files={files} handleFileClick={setFileViewed} />
			}
		}
	
		return (
			<div className="my-files">
				<div className="my-files__header">
					<h2 className="my-files__title">My Files</h2>
				</div>
				<div className="my-files__body">
					<div className="my-files__filters">
						<h4 className="my-files__filters-title">FILTER BY</h4>
						<div className="my-files__filter-bar">
							<Dropdown 
							  title="Investors" 
								options={circles} 
								isActive={isCirclesActive} 
								toggleDropdown={() => toggleDropdown('circles')} 
								toggleItem={(id, selected) => toggleCheckFilter('circles', id, selected)} />
							
							<Dropdown 
							  title="Funds" 
								options={funds} 
								isActive={isFundsActive} 
								toggleDropdown={() => toggleDropdown('funds')} 
								toggleItem={(id, selected) => toggleCheckFilter('funds', id, selected)} />

							<Dropdown 
							  title="File Types" 
								options={types} 
								isActive={isTypesActive} 
								toggleDropdown={() => toggleDropdown('types')} 
								toggleItem={(id, selected) => toggleCheckFilter('types', id, selected)} />

							<Dropdown 
							  title="Years" 
								options={years} 
								isActive={isYearsActive} 
								toggleDropdown={() => toggleDropdown('years')} 
								toggleItem={(id, selected) => toggleCheckFilter('years', id, selected)} />
								
								{showClear &&
									<Button onClick={clearFilters} color="icon">
										<span className="material-icons">close</span>
									</Button>
								}
						</div>
						<ViewToggle toggleView={setView} activeToggle={activeToggle} />
					</div>
					{renderFiles()}
					<Offset 
						currentPage={currentPage}
						pages={pages}
						update={updateCurrentPage} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		files: fromFiles.getFilteredFiles(state.files),
		circles: fromCircles.getCircles(state.circles),
		isCirclesActive: fromCircles.getIsActive(state.circles),
		types: fromTypes.getTypes(state.types),
		isTypesActive: fromTypes.getIsActive(state.types),
		funds: fromFunds.getFunds(state.funds),
		isFundsActive: fromFunds.getIsActive(state.funds),
		years: fromYears.getYears(state.years),
		isYearsActive: fromYears.getIsActive(state.years),
		pages: fromFiles.getNumberOfPages(state.files),
		currentPage: fromFiles.getCurrentPage(state.files),
		view: fromFiles.getView(state.files),
		sort: fromFiles.getSort(state.files),
		order: fromFiles.getOrder(state.files),
		activeToggle: fromFiles.getActiveToggle(state.files),
		showClear: anyActiveFilters(state),
	}
}

export default connect(mapStateToProps, { 
	updateCurrentPage, 
	setView, 
	setFileSortOrder,
	toggleDropdown,
	toggleCheckFilter,
	clearFilters,
	setFileViewed,
})(MyFiles);


// WEBPACK FOOTER //
// ./src/components/routes/MyFiles/index.js